import React from 'react';
import { Field } from '../../types';

export interface FormTermsProps {
    field: Field
}
function FormTerms(props: FormTermsProps) {
  const { field } = props;
  return (
    <div className="mb-4">
      <p dangerouslySetInnerHTML={{ __html: field.text }} className="terms ps-2 kb-border-start" />
    </div>
  );
}

export default FormTerms;
